/**
 * @fileoverview React context for authentication session management.
 */

import { createContext, type Dispatch, type SetStateAction } from 'react';
import type { Session } from '@/app/providers/AppProvider';

export type AuthSession = Session;

interface AuthSessionContextValue {
  session: AuthSession | null;
  setSession: Dispatch<SetStateAction<AuthSession | null>>;
  loading: boolean;
}

const AuthSessionContext = createContext<AuthSessionContextValue>({
  session: null,
  setSession: () => {},
  loading: true,
});

export default AuthSessionContext;